





























import Vue from 'vue'
import SubjectTitle from '../atoms/SubjectTitle.vue'
import PdfItem from '../molecules/PdfItem.vue'

export type PdfContent = {
  id: number
  title: string
  subject_id: number
  icon_subject_id: number
  sort: number
}

export type Subject = {
  name: string
  subject_id: number
}

export default Vue.extend({
  components: { SubjectTitle, PdfItem },
  props: {
    subjects: {
      type: Array as () => Subject[],
    },
    icons: {
      type: Object,
    }
  },
  computed: {
    year(this: { $store: { state: { year: number } } }) {
      return this.$store.state.year
    },
    filteredTexts(
      this: {
        $store: {
          state: {
            year: number | null,
            month: number | null,
            texts: Record<
            string, {
              prints: PdfContent[]
              contents: PdfContent[];
            }
            >
          }
        }
      }
    ): PdfContent[] {
      if (!this.$store.state.year || !this.$store.state.month) return []

      const key =
        this.$store.state.year.toString() +
        ('0' + this.$store.state.month).slice(-2)
      const data = this.$store.state.texts[key]
      return data ? data.prints : []
    },
    filteredSortedText(this: { subjects: Subject[]; filteredTexts: PdfContent[] }) {
      const subjectIdToIndex: {[key: number]: number} = {}
      this.subjects.forEach((subject, index) => {
        subjectIdToIndex[subject.subject_id] = index
      })

      const textsWithIndex = (this.filteredTexts as PdfContent[])
        .map((text: PdfContent, index: number) => ({ text, index }))

      textsWithIndex.sort((a, b) => {
        if (a.text.subject_id != b.text.subject_id) {
          return subjectIdToIndex[a.text.subject_id] - subjectIdToIndex[b.text.subject_id]
        }
        if (a.text.icon_subject_id != b.text.icon_subject_id) {
          return subjectIdToIndex[a.text.icon_subject_id] - subjectIdToIndex[b.text.icon_subject_id]
        }
        if (a.text.sort != b.text.sort) {
          return a.text.sort - b.text.sort
        }
        return a.index - b.index
      })

      return textsWithIndex.map((ti: { text: PdfContent }) => ti.text)
    },
  }
})
